/**
 * True/false field description toggler.
 *
 * ACF true_false fields can include .yes-description and .no-description spans
 * inside the .message element. The span matching the current value gets the
 * "active" class; the other is hidden via CSS.
 *
 * This module:
 *   1. Syncs the active description when the switch is toggled.
 *   2. On ACF ready, sets the correct active class based on the field's
 *      current value (handles prefilled / loaded data).
 */
module.exports = function init_true_false_descriptions($) {

  if (!window.acf) return;

  function sync_description($field) {
    const $input   = $field.find('input[type="checkbox"]');
    const $yes     = $field.find('.yes-description');
    const $no      = $field.find('.no-description');
    const is_checked = $input.is(':checked');
    $yes.toggleClass('active', is_checked);
    $no.toggleClass('active', !is_checked);
  }

  acf.addAction('ready', function () {
    $('.acf-field-true-false').each(function () {
      const $field = $(this);
      if (!$field.find('.yes-description, .no-description').length) return;

      // Set initial state based on current value.
      sync_description($field);

      // Update on toggle.
      $field.find('input[type="checkbox"]').on('change', function () {
        sync_description($field);
      });
    });
  });

};
